import { BaseRow } from 'app/components/common/BaseRow'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { SearchInput } from 'app/components/common/inputs/SearchInput'
import { BaseDatePicker } from 'app/components/common/pickers/BaseDatePicker'
import { BaseSelect } from 'app/components/common/selects/BaseSelect'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import {
  BORDER_RADIUS,
  FONT_SIZE,
  FONT_WEIGHT,
  PADDING,
  media,
} from 'parkway-web-common'
import styled from 'styled-components'

export const HeadWrapper = styled(BaseRow)`
  padding-bottom: ${PADDING.xs};
  .ant-form-item {
    margin-bottom: 0px;
  }
`
export const TitleTable = styled.span`
  font-size: ${FONT_SIZE.xs};
  color: var(--primary-color);
  font-weight: ${FONT_WEIGHT.bold};
`
export const Picker = styled(BaseDatePicker)`
  min-width: 160px;
`

export const TextFilter = styled.span`
  font-size: ${FONT_SIZE.xs};
  font-weight: ${FONT_WEIGHT.regular};
  color: var(--primary-color);
`

export const SelectBaseStyled = styled(BaseSelect)`
  .ant-select-selector {
    border-left: initial !important;
    padding-left: 0px !important;
  }
`

export const InputSearch = styled(SearchInput)`
  .ant-input-group-addon {
    display: none;
  }

  @media only screen and (${media.md}) {
    .ant-input-group .ant-input-affix-wrapper:not(:last-child) {
      border-radius: ${BORDER_RADIUS};
      border-color: var(--neutral-black-color);
      padding: 0px ${PADDING.xxxxs};
    }
  }
`

export const SelectLabel = styled(BaseInput)`
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  &.ant-input[disabled] {
    color: var(--text-main-color) !important;
    background: ${convertedVariables.backgroundColor} !important;
    border: 1px solid var(--inventory-border-color) !important;
    color: var(--inventory-text-color2) !important;
    width: 110px;
    max-width: 100%;
    border-right: initial !important;
    padding-right: 0px;
    text-align: left;
  }
`


export const SelectInputSearch = styled(BaseSelect)`
  .ant-select-selector {
    min-width: 232px;
    border-left: initial !important;
  }
  .ant-select-arrow {
    top: 50% !important;
  }

  &.require {
    border: 1px solid var(--inventory-border-color2);
    border-radius: 7px;
  }
`